import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { AgentsComponentsModule } from './agents-components.module';
import { ClientsModule } from '../clients/clients.module';
import { GroupsComponentsModule } from 'app/groups/groups-components.module';
import { AgentsRoutingModule } from './agents-routing.module';
import { AgentsQuestionsService } from './services/agents-questions.service';
import { UiService } from '../core';
import { AgentDetailComponent } from './agent-detail/agent-detail.component';
import { AgentsComponent } from './agents/agents.component';
import { AgentEditorComponent } from './agent-editor/agent-editor.component';
import { AgentCreateComponent } from './agent-create/agent-create.component';
import { TransferAgentAccountsComponent } from './transfer-agent-accounts/transfer-agent-accounts.component';
import { EmailsModule } from '../emails/emails.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    ClientsModule,
    GroupsComponentsModule,
    AgentsRoutingModule,
    EmailsModule,
    AgentsComponentsModule
  ],
  declarations: [
    AgentDetailComponent,
    AgentsComponent,
    AgentEditorComponent,
    AgentCreateComponent,
    TransferAgentAccountsComponent
  ],
  exports: [AgentEditorComponent],
  providers: [AgentsQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AgentsModule {
  constructor(public uiService: UiService) {}
}
